import styled from "styled-components";
import { colors } from "../../../libs";

export const ListContainer = styled.div``;

export const PaginationContainer = styled.div`
  position: fixed;
  bottom: 5px;
  right: 40px;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  .pagination {
    display: flex;
    gap: 5px;
  }

  .page-item {
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;

    .page-link {
      background-color: ${colors.background.black};;
    }

    .page-link:hover {
      background-color: ${colors.background.black};
      color: white;
    }

    &.active {
      .page-link {
        background-color: ${colors.background.green};
        color: white;
      }
    }

    &.disabled {
      .page-link {
        color: ${colors.text.lightGray};;
        pointer-events: none;
      }
    }
  }
`;
